import type { DatasourceProps } from "types/datasource.d";

const showAntiFlickerScript = (datasources: DatasourceProps[], path: string) => {
  let show = false;

  if (typeof datasources !== "undefined") {
    datasources.forEach((datasource) => {
      const { name: matchPath, value: matchType } = datasource;
      const exactPathMatch = matchType === "exact" && path.split("?")[0] === matchPath;
      const containingPathMatch = matchType === "contains" && path.includes(matchPath);

      if (exactPathMatch || containingPathMatch) show = true;
    });
  }

  return show;
};

export default showAntiFlickerScript;
